import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import MarketYourTransactionsLayout from '../MarketYourTransactionsLayout';

/** Sized to the first page of the wallet's feed: pagination appears once the feed reports another page. */
const MarketYourTransactionsLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MarketYourTransactionsLayout tableSettingsSlot={<Skeleton className="h-[28px] w-[127px] rounded-[20px]" />}><Skeleton className="h-[478px] w-[100%] rounded-[20px]" /></MarketYourTransactionsLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default MarketYourTransactionsLoading;